import _ from 'lodash';
import moment from 'moment';
import pushid from 'pushid';

export const toJSSafe = (obj) => {
  if (obj) {
    return obj.toJS();
  }

  return null;
};

export const toArray = (obj) => _.keys(obj).map((id) => _.assign({ id }, obj[id]));
export const toMap = (arr) => _.reduce(arr, (res, item) => _.assign({}, res, { [item.id]: item }), {});

export const replaceAll = (str, find, replace) => str.replace(new RegExp(find, 'g'), replace);

export const convertIconName = (icon) => replaceAll(icon, '-', '_');
export const contains = (string = '', substring = '', ignoreCase = true) => (ignoreCase ? string.toLowerCase() : string).includes(ignoreCase ? substring.toLowerCase() : substring);
export const isEqual = (string, substring) => string === substring;
export const isEmpty = (value) => !value;

export const filterData = (value, condition, substring) => {
  switch (condition) {
    case 'Contains':
      return contains(value.toLowerCase(), substring.toLowerCase());
    case 'Does not contain':
      return !substring || !contains(value.toLowerCase(), substring.toLowerCase());
    case 'Is':
      return isEqual(value.toLowerCase(), substring.toLowerCase());
    case 'Is not':
      return !isEqual(value.toLowerCase(), substring.toLowerCase());
    case 'Is empty':
      return isEmpty(value.toLowerCase(), substring.toLowerCase());
    case 'Is not empty':
      return !isEmpty(value.toLowerCase(), substring.toLowerCase());
    default:
      return true;
  }
};

export const filterTask = (task, rules = []) => rules.reduce((res, rule) => {
  if (res) {
    // console.log(rule.where(task), rule.condition, rule.substring);
    return filterData(rule.where(task), rule.condition, rule.substring);
  }

  return res;
}, true);

export const getStageStatus = (task, stage) => {
  if (!task) {
    return {
      code: 'U',
      name: 'Unknown',
      icon: 'unknown',
      color: 'lightgrey',
    };
  }

  if (!task.stages || !task.stages[stage.id]) {
    return {
      code: 'P',
      name: 'Pending',
      icon: 'clear',
      color: 'grey',
    };
  }

  const taskStage = task.stages[stage.id];
  if (taskStage.skipped) {
    return {
      code: 'SK',
      name: 'Skipped',
      icon: 'skip_next',
      color: 'grey',
    };
  }

  if (taskStage.completed) {
    return {
      code: 'C',
      name: 'Complete',
      icon: 'done',
      color: 'green',
    };
  }

  if (taskStage.started) {
    return {
      code: 'IP',
      name: 'In Progress',
      icon: 'autorenew',
      color: 'orange',
    };
  }

  return {
    code: 'P',
    name: 'Pending',
    icon: 'clear',
    color: 'red',
  };
};

export const getLastStageCompletion = (task, stage) => {
  if (task.stages) {
    const taskStage = task.stages[stage.id];
    console.log('taskStage,', taskStage);
    if (taskStage && taskStage.completed) {
      const completion = toArray(taskStage.completed).reduce((res, completion) => {
        if (!res) {
          return completion;
        } else if (moment(completion.at).isAfter(res.at)) {
          return completion;
        }

        return res;
      }, null);

      console.log('completion', completion);

      return completion;
    }
  }

  return null;
};

export const validateEmail = (email) => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
export const validateMobile = (mobile) => /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(mobile);
export const splitCamelCase = (camelCase) => camelCase.replace(/([A-Z])/g, ' $1').toLowerCase();
export const isStageComplete = (task, stage) => getStageStatus(task, stage).code === 'C';
export const isStageInProgress = (task, stage) => getStageStatus(task, stage).code === 'IP';
export const isStageSkipped = (task, stage) => getStageStatus(task, stage).code === 'SK';
export const isStagePending = (task, stage) => getStageStatus(task, stage).code === 'P';

export const countries = ['Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla',
  'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bangladesh',
  'Barbados', 'Bahamas', 'Bahrain', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia',
  'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'British Indian Ocean Territory', 'British Virgin Islands',
  'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde',
  'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands',
  'Colombia', 'Comoros', 'Congo-Brazzaville', 'Congo-Kinshasa', 'Cook Islands', 'Costa Rica', 'Croatia', 'Curaçao', 'Cyprus',
  'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'El Salvador', 'Egypt',
  'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Federated States of Micronesia',
  'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Lands', 'Gabon', 'Gambia', 'Georgia',
  'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea',
  'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard and McDonald Islands', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India',
  'Indonesia', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan',
  'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein',
  'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta',
  'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Moldova', 'Monaco', 'Mongolia',
  'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia',
  'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway',
  'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn Islands',
  'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russia', 'Rwanda', 'Saint Barthélemy', 'Saint Helena',
  'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin', 'Saint Pierre and Miquelon', 'Saint Vincent', 'Samoa', 'San Marino',
  'São Tomé and Príncipe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten',
  'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'South Korea', 'Spain', 'Sri Lanka',
  'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Sweden', 'Swaziland', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan',
  'Tanzania', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan',
  'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu',
  'Vatican City', 'Vietnam', 'Venezuela', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'];

export const isFutureDate = (selectedText) => {
  const selectedDate = new Date(selectedText);
  const now = new Date();
  if (selectedDate < now) {
    return false;
  }
  return true;
};

export const isValidDates = (startDateText, endDateText) => {
  const startDate = new Date(startDateText);
  const endDate = new Date(endDateText);
  if (endDate < startDate) {
    return false;
  }
  return true;
};

export const customizedFuzzyFilter = (searchText = '', key = '') => {
  if ((key.indexOf(' -- Add New') !== -1) || !searchText) {
    return true;
  }

  const compareString = key.toLowerCase();
  searchText = searchText.trim().toLowerCase();

  let searchTextIndex = 0;
  for (let index = 0; index < key.length; index += 1) {
    if (compareString[index] === searchText[searchTextIndex]) {
      searchTextIndex += 1;
    }
  }

  return searchTextIndex === searchText.length;
};

// TODO review
export const objectArraySorter = (objArray, keyToSortWith, order) => (
  objArray.sort((a, b) => {
    let textA;
    let textB;
    switch (keyToSortWith) {
      case 'name':
        textA = a[keyToSortWith] ? a[keyToSortWith].toUpperCase() : '';
        textB = b[keyToSortWith] ? b[keyToSortWith].toUpperCase() : '';
        break;
      case 'customerManager':
        textA = a[keyToSortWith] ? a[keyToSortWith].name.toUpperCase() : '';
        textB = b[keyToSortWith] ? b[keyToSortWith].name.toUpperCase() : '';
        break;
      case 'contacts':
        textA = a.primaryContactId && a.contacts && a.contacts[a.primaryContactId] ? a.contacts[a.primaryContactId].firstName.toUpperCase() : '';
        textB = b.primaryContactId && b.contacts && b.contacts[b.primaryContactId] ? b.contacts[b.primaryContactId].firstName.toUpperCase() : '';
        break;
      case 'role':
        textA = a.roles ? a.roles[0].name.toUpperCase() : '';
        textB = b.roles ? b.roles[0].name.toUpperCase() : '';
        break;
      case 'jobCustomer':
        textA = a.customer ? a.customer.name.toUpperCase() : '';
        textB = b.customer ? b.customer.name.toUpperCase() : '';
        break;
      case 'jobCustomerContact':
        textA = a.customerContact ? a.customerContact.name.toUpperCase() : '';
        textB = b.customerContact ? b.customerContact.name.toUpperCase() : '';
        break;
      case 'jobContact':
        textA = a.jobContact ? a.jobContact.name.toUpperCase() : '';
        textB = b.jobContact ? b.jobContact.name.toUpperCase() : '';
        break;
      case 'jobStart':
        textA = a.start ? new Date(a.start) : '';
        textB = b.start ? new Date(b.start) : '';
        break;
      case 'jobEnd':
        textA = a.end ? new Date(a.end) : '';
        textB = b.end ? new Date(b.end) : '';
        break;
      default:
    }

    if (order === 'asc') {
      return (textA < textB) ? -1 : (textA > textB) ? 1 : sortStrings(a.id, b.id);
    } else if (order === 'dsc') {
      return (textA > textB) ? -1 : (textA < textB) ? 1 : sortStrings(a.id, b.id);
    }
  })
);

export const sortStrings = (a = '', b = '', ignoreCase = true) => {
  const x = ignoreCase ? a.toLowerCase() : a;
  const y = ignoreCase ? b.toLowerCase() : b;

  if (x > y) {
    return 1;
  } else if (x < y) {
    return -1;
  }

  return 0;
};

export const sortDates = (a, b) => {
  if (moment(a).isBefore(moment(b))) {
    return -1;
  } else if (moment(b).isBefore(moment(a))) {
    return 1;
  }

  return 0;
};

export const sortByLocation = (a, b) => {
  if (a === b) {
    return 0;
  }

  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }

  let result = sortStrings(a.building, b.building);
  if (result === 0) {
    result = sortStrings(a.floor, b.floor);
    if (result === 0) {
      result = sortStrings(a.space, b.space);
    }
  }

  return result;
};

export const formatAddress = (address = {}) => `${address.line1 || ''}${address.line2 ? `, ${address.line2}` : ''}, ${address.city || ''}, ${address.state || ''}, ${address.postalCode}, ${address.country}`;

// TODO move to common
export const formatLocation = (location = {}) => {
  let result = '';
  if (location.building) {
    result += `${location.building}, `;
  }
  if (location.floor) {
    result += `${location.floor}, `;
  }
  if (location.space) {
    result += location.space;
  }

  return result;
};

export const getOrderDirection = (order) => order === 'asc' ? 1 : -1;

export const parseApiErrorCode = (code) => {
  switch (code) {
    case 'Unauthorized':
      return 'You are not authorized to access this page';
    default:
      return 'Unknown Error';
  }
};

export const buildInvoiceItemDescription = (line) => {
  if (!line.description && line.type === 'subscription') {
    return `${line.plan.name} from ${moment(line.period.start).format('ll')} to ${moment(line.period.end).format('ll')}`;
  }

  return line.description;
};

export const convertCollection = (col) => {
  const docs = {};

  col.forEach((doc) => {
    docs[doc.id] = _.assign(doc.data(), { id: doc.id });
  });

  return docs;
};

export const convertDocument = (doc) => {
  if (doc.exists) {
    return doc.data();
  }

  return null;
};

/*
 https://stackoverflow.com/questions/46618719/firestore-are-ids-unique-in-the-collection-or-globally/46621206#46621206
 */
export const id = () => pushid();



// WEBPACK FOOTER //
// ./src/utils/helper.js